import { render, staticRenderFns } from "./DepartmentsListFilters.vue?vue&type=template&id=ccb98e04&"
import script from "./DepartmentsListFilters.vue?vue&type=script&lang=js&"
export * from "./DepartmentsListFilters.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentsListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports